import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _class;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "0337dK0z1NGBrGKKYZ0IbdD", "RedDotAct", undefined);

import { _decorator, Component, tween, v3 } from 'cc';
var ccclass = _decorator.ccclass,
    property = _decorator.property;
export var RedDotAct = (_dec = ccclass('RedDotAct'), _dec(_class = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RedDotAct, _Component);

  function RedDotAct() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = RedDotAct.prototype;

  // [1]
  // dummy = '';
  // [2]
  // @property
  // serializableDummy = 0;
  _proto.start = function start() {
    // [3]
    tween(this.node).repeatForever(tween().by(1, {
      position: v3(0, 10, 0)
    }).by(1, {
      position: v3(0, -10, 0)
    })).start();
  } // update (deltaTime: number) {
  //     // [4]
  // }
  ;

  return RedDotAct;
}(Component)) || _class);
/**
 * [1] Class member could be defined like this.
 * [2] Use `property` decorator if your want the member to be serializable.
 * [3] Your initialization goes here.
 * [4] Your update function goes here.
 *
 * Learn more about scripting: https://docs.cocos.com/creator/3.0/manual/en/scripting/
 * Learn more about CCClass: https://docs.cocos.com/creator/3.0/manual/en/scripting/ccclass.html
 * Learn more about life-cycle callbacks: https://docs.cocos.com/creator/3.0/manual/en/scripting/life-cycle-callbacks.html
 */

_cclegacy._RF.pop();